export default __webpack_public_path__ + "static/media/PTAC-Full Logo-SidexSide.409be6dc.png";